import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {BodyMeasurementsDependencies} from '../dependencies';
import {keys} from './keys';

export type GetMeasurementsOverviewQueryDependencies = Pick<
  BodyMeasurementsDependencies,
  'controllers'
>;

export const getMeasurementsOverviewQuery = ({
  controllers,
}: GetMeasurementsOverviewQueryDependencies) =>
  queryOptions({
    queryKey: keys.overview(),
    queryFn: () => controllers.bodyMeasurementsController.overview().then(unwrap),
  });
